// Referências externas
import { useState, useEffect } from 'react';
import { FiPlus, FiUserPlus, FiEdit, FiTrash2, FiDownload } from 'react-icons/fi';
// import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Referências internas
import { Header, Loading, DynamicLoading } from '../../common';
import api from '../../services/api';
import ModalCadastrarColaborador from './ModalCadastrarColaborador/ModalCadastrarColaborador';
import ModalEditarColaborador from './ModalEditarColaborador/ModalEditarColaborador';
import ModalCadastrarAcidente from './ModalCadastrarAcidente/ModalCadastrarAcidente';
import ModalEditarAcidente from './ModalEditarAcidente/ModalEditarAcidente';
import { BotaoImprimir } from './RelatorioAcidente/RelatorioAcidente';

// Estilo
import './styles.css';

// Referências internas
// const permissaoUsuario = require('../../services/permissaoUsuario');

export default function HSEQ() {
    // const history = useHistory();

    const [done, setDone] = useState(true);

    const [listaColaborador, setListaColaborador] = useState([]);
    const [listaUsuariosCorrespondentes, setListaUsuariosCorrespondentes] = useState([]);

    const [listaAcidente, setListaAcidente] = useState([]);

    const [diasSemAcidente, setDiasSemAcidente] = useState(0);
    const [apenasPrimeirosSocorros, setApenasPrimeirosSocorros] = useState(0);
    const [afastamentoAte3, setAfastamentoAte3] = useState(0);
    const [afastamentoAte30, setAfastamentoAte30] = useState(0);
    const [afastamentoMaior30, setAfastamentoMaior30] = useState(0);

    // #################### INÍCIO Modal Cadastrar Colaborador ####################
    const [modalCadastrarColaboradorAberto, setModalCadastrarColaboradorAberto] = useState(false);
    const [doneCadastrarColaborador, setDoneCadastrarColaborador] = useState(true);

    async function cadastrarColaborador(objectCadastrarColaborador) {
        setDoneCadastrarColaborador(false);

        try {
            objectCadastrarColaborador = {
                id_colaborador: parseInt(objectCadastrarColaborador.matricula_colaborador.slice(2), 10),
                ...objectCadastrarColaborador,
            }
            
            const responsePostColaborador = await api.post('hseq/colaborador', objectCadastrarColaborador);

            setDoneCadastrarColaborador(true);
            setDadosEditarColaborador(responsePostColaborador.data.result_consulta_colaborador_cadastrado[0]);
            setListaColaborador(responsePostColaborador.data.result_colaborador);
            setModalCadastrarColaboradorAberto(false);
            setModalEditarColaboradorAberto(true);
            notificarSucessoGenerico();

        } catch (error) {
            setDoneCadastrarColaborador(true);
            notificarErroPersonalizado(error);
            console.log('Erro: cadastrarColaborador');
        }
    }
    // #################### FIM Modal Cadastrar Colaborador ####################

    // #################### INÍCIO Modal Editar Colaborador ####################
    const [modalEditarColaboradorAberto, setModalEditarColaboradorAberto] = useState(false);
    const [dadosEditarColaborador, setDadosEditarColaborador] = useState({
        matricula_colaborador: '',
        id_usuario_colaborador: '',
        colaborador_ativo: '',
        nome_colaborador: '',
        nome_completo_colaborador: '',
        email_colaborador: '',
        funcao_colaborador: '',
        setor_colaborador: '',
        id_colaborador_superior_imediato: '',
        telefone1_usuario: '',
        telefone2_usuario: '',
        vinculo_colaborador: '',
    });
    const [doneEditarColaborador, setDoneEditarColaborador] = useState(true);

    async function editarColaborador(objectEditarColaborador) {
        setDoneEditarColaborador(false);

        try {
            const responseEditarColaborador = await api.patch('hseq/colaborador', objectEditarColaborador);
            
            setDoneEditarColaborador(true);
            setListaColaborador(responseEditarColaborador.data.result_colaborador);
            setDadosEditarColaborador(responseEditarColaborador.data.result_consulta_colaborador_editado[0]);
            notificarSucessoGenerico();

        } catch (error) {
            setDoneEditarColaborador(true);
            notificarErroPersonalizado(error);
            console.log('Erro: editarColaborador');
        }
    }
    // #################### FIM Modal Editar Colaborador ####################



    
    // #################### INÍCIO Modal Cadastrar Acidente ####################
    const [modalCadastrarAcidenteAberto, setModalCadastrarAcidenteAberto] = useState(false);
    const [doneCadastrarAcidente, setDoneCadastrarAcidente] = useState(true);
    const [formCadastrarAcidenteFoiEnviado, setFormCadastrarAcidenteFoiEnviado] = useState(false);
    const [formEditarAcidenteFoiEnviado, setFormEditarAcidenteFoiEnviado] = useState(false);

    function formatarDataHoraParaMySQL(dataHoraLocal) {
        const data = new Date(dataHoraLocal);
        const doisDigitos = num => num.toString().padStart(2, '0');
        return `${data.getFullYear()}-${doisDigitos(data.getMonth() + 1)}-${doisDigitos(data.getDate())} ` +
        `${doisDigitos(data.getHours())}:${doisDigitos(data.getMinutes())}:${doisDigitos(data.getSeconds())}`;
    }

    async function cadastrarAcidente(objectCadastrarAcidente) {
        setDoneCadastrarAcidente(false);

        try {
            let objectCadastrarAcidenteFormatado = {
                ...objectCadastrarAcidente,
                data_hora_acidente: formatarDataHoraParaMySQL(objectCadastrarAcidente.data_hora_acidente),
            }

            console.log(objectCadastrarAcidenteFormatado)

            const responsePostAcidente = await api.post('hseq/acidente', objectCadastrarAcidenteFormatado);

            setDoneCadastrarAcidente(true);
            setListaAcidente(responsePostAcidente.data.result_acidente);
            setFormCadastrarAcidenteFoiEnviado(true);
            setModalCadastrarAcidenteAberto(false);
            setDadosEditarAcidente(responsePostAcidente.data.result_consulta_acidente_cadastrado[0]);
            setModalEditarAcidenteAberto(true);
            notificarSucessoGenerico();

        } catch (error) {
            setDoneCadastrarAcidente(true);
            notificarErroPersonalizado(error);
            console.log('Erro: cadastrarAcidente');
        }
    }
    // #################### FIM Modal Cadastrar Acidente ####################


    // #################### INÍCIO Modal Editar Acidente ####################
    const [modalEditarAcidenteAberto, setModalEditarAcidenteAberto] = useState(false);
    const [dadosEditarAcidente, setDadosEditarAcidente] = useState({
            id_acidente: '',
            revisao_acidente: '',
            id_colaborador_acidentado: '',
            id_usuario_responsavel_registro: '',
            id_colaborador_supervisor_acidente: '',
            data_acidente: '',
            local_acidente_resumido: '',
            vinculo_colaborador_acidente: '',
            setor_colaborador_acidente: '',
            funcao_colaborador_acidente: '',
            meses_colaborador_funcao_acidente: '',
            testemunha_acidente: '',
            descricao_local_acidente: '',
            endereco_local_acidente: '',
            apenas_pimeiros_socorros: '',
            afastamento_ate_3: '',
            afastamento_entre_4_e_30: '',
            afastamento_maior_30: '',
            obito: '',
            choque_eletrico_baixa_tensao: '',
            choque_eletrico_alta_tensao: '',
            arco_eletrico: '',
            explosao_painel_eletrico: '',
            queda_mesma_altura: '',
            queda_altura_elevada: '',
            escorregao_ou_tropeco: '',
            impacto_objeto_movel: '',
            colisao_veiculo_ou_maquina: '',
            prensamento: '',
            corte_ou_laceracao: '',
            perfuracao: '',
            esmagamento: '',
            entorse_ou_luxacao: '',
            fratura: '',
            queimadura_termica: '',
            queimadura_quimica: '',
            incendio_ou_principio: '',
            inalacao: '',
            contato_produto_quimico: '',
            vazamento: '',
            intoxicacao: '',
            mordida_ou_picada: '',
            alagamento_vendaval_deslizamento: '',
            falha_equipamento_maquina: '',
            falha_andaime_plataforma: '',
            deficiencia_iluminacao: '',
            violencia: '',
            deslocamento: '',
            outro_tipo_acidente: '',
            atendimento_medico: '',
            local_atendimento_medico: '',
            descricao_acidente: '',
            iluminacao_boa: '',
            clima: '',
            piso_seco: '',
            presenca_outros_riscos: '',
            outros_riscos: '',
            epi_presente: '',
            epi_ausente: '',
            epi_observacoes: '',
            ato_inseguro_trabalhador: '',
            desatencao_distracao: '',
            pressa: '',
            excesso_confianca: '',
            falta_treinamento: '',
            uso_inadequado_ferramentas: '',
            improvisacao: '',
            fadiga: '',
            negligencia_procedimentos: '',
            falha_equipamento: '',
            falta_manutencao_preventiva: '',
            equipamento_defeito_conhecido: '',
            equipamento_inadequado: '',
            ausencia_dispositivo_protecao: '',
            projeto_inadequado: '',
            iluminacao_inadequada: '',
            ruido_excessivo: '',
            temperatura_extrema: '',
            piso_inseguro: '',
            obstrucao_rotas: '',
            sinalizacao_inadequada: '',
            nao_uso_epi: '',
            uso_incorreto_epi: '',
            epi_danificado_ou_ineficaz: '',
            falta_epi: '',
            intrucao_inadeqada: '',
            falta_planejamento: '',
            mudanca_tarefa: '',
            falha_comunicacao: '',
            supervisao_ineficiente: '',
            ausencia_procedimento: '',
            interferencia_terceiros: '',
            fatores_climaticos: '',
            evento_externo_nao_previsto: '',
            outra_causa_acidente: '',
            descricao_outra_causa_acidente: '',
            acoes_corretivas_preventivas: '',
            observacoes_finais_licoes_aprendidas: '',
    });
    const [doneEditarAcidente, setDoneEditarAcidente] = useState(true);

    const excluirAcidente = async (acidente) => {
        if (!window.confirm('Deseja realmente excluir este acidente?')) return;

        try {
            const response = await api.delete(`/hseq/acidente/${acidente.id_acidente}/${acidente.revisao_acidente}`);
            alert('Acidente excluído com sucesso');
            
            setListaAcidente(prev => prev.filter(item =>
                !(item.id_acidente === acidente.id_acidente && item.revisao_acidente === acidente.revisao_acidente)
            ));

        } catch (error) {
            console.error(error);
            alert('Erro ao excluir acidente');
        }
    };

    async function editarAcidente(objectEditarAcidente) {
        setDoneEditarAcidente(false);

        try {
            const responseEditarAcidente = await api.patch('hseq/acidente', objectEditarAcidente);
            
            setDoneEditarAcidente(true);
            setListaAcidente(responseEditarAcidente.data.result_acidente);
            setDadosEditarAcidente(responseEditarAcidente.data.result_consulta_acidente_editado);
            setFormEditarAcidenteFoiEnviado(true);
            setModalEditarAcidenteAberto(false);
            notificarSucessoGenerico();

        } catch (error) {
            setDoneEditarAcidente(true);
            notificarErroPersonalizado(error);
            console.log('Erro: editarAcidente');
        }
    }
    // #################### FIM Modal Editar Acidente ####################

    async function exportarAcidentesCSV() {
        function gerarNomeArquivoCSVLocal() {
            const agora = new Date();

            const doisDigitos = (num) => String(num).padStart(2, '0');

            const ano = agora.getFullYear();
            const mes = doisDigitos(agora.getMonth() + 1);
            const dia = doisDigitos(agora.getDate());

            const hora = doisDigitos(agora.getHours());
            const minuto = doisDigitos(agora.getMinutes());
            const segundo = doisDigitos(agora.getSeconds());

            return `acidente_${ano}-${mes}-${dia}_${hora}-${minuto}-${segundo}.csv`;
        }

        try {

            const response = await api.get('hseq/acidente/exportar-acidentes-csv', {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', gerarNomeArquivoCSVLocal());
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            notificarSucessoGenerico();
            

        } catch (error) {
            notificarErroPersonalizado(error);
            console.log('Erro: exportarAcidentesCSV');
        }
    }
    const notificarSucessoGenerico = () => {
        toast.success('Operação executada com sucesso!', {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const notificarErroPersonalizado = (error) => {
        const mensagem_erro = (typeof error.response !== "undefined") ? error.response.data.error : "";

        toast.error(`Erro ao estabelecer conexão com o servidor ${mensagem_erro}`, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    useEffect(() => {
        document.title = `SGC Brazil Solution`;

        async function solicitarHSEQ() {
            setDone(false);
            try {
                const responseDados = await api.get('hseq')
                setListaColaborador(responseDados.data.result_colaborador);
                setListaUsuariosCorrespondentes(responseDados.data.result_usuario);
                setListaAcidente(responseDados.data.result_acidente);

                setDiasSemAcidente(responseDados.data.dias_sem_acidente);
                setApenasPrimeirosSocorros(responseDados.data.numero_acidentes.apenas_pimeiros_socorros);
                setAfastamentoAte3(responseDados.data.numero_acidentes.afastamento_ate_3);
                setAfastamentoAte30(responseDados.data.numero_acidentes.afastamento_entre_4_e_30);
                setAfastamentoMaior30(responseDados.data.numero_acidentes.afastamento_maior_30);
             
            } catch (error) {
                notificarErroPersonalizado(error);
            }
            setDone(true);

        }

        solicitarHSEQ();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="container">
            <Header />
            <ToastContainer />

            { (modalCadastrarColaboradorAberto && done) &&
                <ModalCadastrarColaborador
                    cadastrarColaborador={cadastrarColaborador}
                    doneCadastrarColaborador={doneCadastrarColaborador}
                    listaUsuariosCorrespondentes={listaUsuariosCorrespondentes}
                    listaColaborador={listaColaborador}
                    fecharModal={() => setModalCadastrarColaboradorAberto(false)}
            /> }

            { (modalEditarColaboradorAberto && done) &&
                <ModalEditarColaborador
                    dadosEditarColaborador={dadosEditarColaborador}
                    editarColaborador={editarColaborador}
                    doneEditarColaborador={doneEditarColaborador}
                    listaUsuariosCorrespondentes={listaUsuariosCorrespondentes}
                    listaColaborador={listaColaborador}
                    fecharModal={() => setModalEditarColaboradorAberto(false)}
            /> }

            { (modalCadastrarAcidenteAberto && done) &&
                <ModalCadastrarAcidente
                    cadastrarAcidente={cadastrarAcidente}
                    doneCadastrarAcidente={doneCadastrarAcidente}
                    listaAcidente={listaAcidente}
                    fecharModal={() => setModalCadastrarAcidenteAberto(false)}
                    listaColaborador={listaColaborador}
                    listaUsuariosCorrespondentes={listaUsuariosCorrespondentes}
                    formCadastrarAcidenteFoiEnviado={formCadastrarAcidenteFoiEnviado}
            /> }

            { (modalEditarAcidenteAberto && done) &&
                <ModalEditarAcidente
                    dadosEditarAcidente={dadosEditarAcidente}
                    editarAcidente={editarAcidente}
                    doneEditarAcidente={doneEditarAcidente}
                    listaAcidente={listaAcidente}
                    fecharModal={() => setModalEditarAcidenteAberto(false)}
                    listaColaborador={listaColaborador}
                    listaUsuariosCorrespondentes={listaUsuariosCorrespondentes}
                    formEditarAcidenteFoiEnviado={formEditarAcidenteFoiEnviado}
            /> }

            <div className="body-container-2-margem-inferior-menor">

                <div className="type1-element">
                    <div className="type1-top-line">
                        <div className="type1-title">GESTÃO DE HSEQ</div>
                        </div>

                        {!done ? (
                            <div>
                                <Loading />
                            </div>
                        )  :  (
                            <ul className='resumo-hseq'>
                                <li>
                                    <span><strong>Dias sem acidentes:</strong></span> <div>{diasSemAcidente}</div>
                                </li>
                                <li>
                                    <span>Número de acidentes com <strong>apenas primeiros socorros</strong>: </span> <div>{apenasPrimeirosSocorros}</div>
                                </li>
                                <li>
                                    <span>Número de acidentes com afastamento <strong>até 3 dias</strong>:</span> <div>{afastamentoAte3}</div>
                                </li>
                                <li>
                                    <span>Número de acidentes com afastamento <strong>entre 4 e 30 dias</strong>:</span> <div>{afastamentoAte30}</div>
                                </li>
                                <li>
                                    <span>Número de acidentes com afastamento <strong>maior que 30 dias</strong>:</span> <div>{afastamentoMaior30}</div>
                                </li>
                            </ul>
                        )}
    
                    </div>

                <div className="body-container-3-com-margem-superior">
                    <div className="type1-element">
                        <div className="bloco2-painel-controle-cabecalho">
                            <h3> Acidentes Registrados </h3>
                            {!done ? (
                                <button style={{width: "146px", height: "30px"}} disabled className="type1-main-button" >
                                    <DynamicLoading height={"40px"} />
                                </button>
                            )  :  (
                                <>
                                    <button className="type1-main-button" onClick={() => {setModalCadastrarAcidenteAberto(true); setFormCadastrarAcidenteFoiEnviado(false);}} >
                                        <FiUserPlus/>
                                        <span>Registrar Acidente</span>
                                    </button>
                                    <button style={{marginLeft: "15px"}} className="type1-main-button" onClick={() => {exportarAcidentesCSV()}} >
                                        <FiDownload/>
                                        <span>Exportar Acidentes</span>
                                    </button>
                                </>
                            )}
                        </div>

                        {!done ? (
                            <div>
                                <Loading />
                            </div>
                        )  :  (
                            <div className="input-group-painel-controle">
                                <table className="table-visualizacao">
                                    <thead>
                                        <tr className="texto-center-children">
                                            <th className="texto-center" style={{width: "65px"}} >ID acidente</th>
                                            <th className="texto-center" style={{width: "65px"}} >Revisão acidente</th>
                                            <th className="texto-center">Colaborador acidentado</th>
                                            <th className="texto-center">Data do acidente</th>
                                            <th className="texto-center">Responsável pelo registro</th>
                                            <th className="texto-center">Data de registro</th>
                                            <th className="texto-center">Editar</th>
                                            <th className="texto-center">Imprimir</th>
                                            <th className="texto-center">Excluir</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listaAcidente.length > 0 && listaAcidente
                                            .map(acidente => {
                                                return(
                                                    <tr key={acidente.id_acidente}>
                                                        <td>{acidente.id_acidente}</td>
                                                        <td>{acidente.revisao_acidente}</td>
                                                        <td>{acidente.nome_vitima}</td>
                                                        <td>{new Date(acidente.data_hora_acidente).toLocaleString('pt-BR')}</td>
                                                        <td>{acidente.nome_responsavel_registro}</td>
                                                        <td>{new Date(acidente.data_hora_registro_acidente).toLocaleString('pt-BR')}</td>
                                                        <td>
                                                            <div>
                                                                <button onClick={() => {setDadosEditarAcidente(acidente); setModalEditarAcidenteAberto(true); setFormEditarAcidenteFoiEnviado(false);}} className="edit1">
                                                                    <FiEdit size={18} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <BotaoImprimir dados={acidente} />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <button onClick={() => {excluirAcidente(acidente)}} className="delete1">
                                                                    <FiTrash2 size={18} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>

                {/* <div className="wrapper-blocos-painel-controle-2">
                    <div className="bloco2-painel-controle">
                        <div className="bloco2-painel-controle-cabecalho">
                            <h3> Ocorrências Registradas </h3>
                            <button className="type1-main-button"  > 
                                <FiPlus size={18} />
                                <span>Registrar ocorrência</span>
                            </button>
                        </div>
                        <div className="input-group-painel-controle">
                            <table className="table-pre-visualizacao">
                                <thead>
                                    <tr className="texto-center-children">
                                        <th className="texto-center"
                                        // tabela-sem-quebra-linha
                                            >Colaborador afetado</th>
                                        <th className="texto-center">Data do acidente</th>
                                        <th className="texto-center">Responsável pelo registro</th>
                                        <th className="texto-center">Data de registro</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="bloco2-painel-controle">
                        <div className="bloco2-painel-controle-cabecalho">
                            <h3> Registro de EPI </h3>
                            <button className="type1-main-button"  > 
                                <FiPlus size={18} />
                                <span>Registrar EPI</span>
                            </button>
                        </div>
                        <div className="input-group-painel-controle">
                            <table className="table-pre-visualizacao">
                                <thead>
                                    <tr className="texto-center-children">
                                        <th className="texto-center"
                                        // tabela-sem-quebra-linha
                                            >Colaborador acidentado</th>
                                        <th className="texto-center">Data do acidente</th>
                                        <th className="texto-center">Responsável pelo registro</th>
                                        <th className="texto-center">Data de registro</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="body-container-3-sem-margem-superior">
                    <div className="type1-element">
                        <div className="bloco2-painel-controle-cabecalho">
                            <h3> Equipamentos Registrados </h3>
                            <button className="type1-main-button"  > 
                                <FiPlus size={18} />
                                <span>Registrar equipamento</span>
                            </button>
                        </div>
                        <div className="input-group-painel-controle">
                            <table className="table-pre-visualizacao">
                                <thead>
                                    <tr className="texto-center-children">
                                        <th className="texto-center"
                                        // tabela-sem-quebra-linha
                                            >Colaborador afetado</th>
                                        <th className="texto-center">Data do acidente</th>
                                        <th className="texto-center">Responsável pelo registro</th>
                                        <th className="texto-center">Data de registro</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> */}

                <div className="body-container-3-com-margem-superior">
                    <div className="type1-element">
                        <div className="painel-controle-top-line2">
                            <h3>
                                Colaboradores
                            </h3>

                            {!done ? (
                                <button style={{width: "170px", height: "30px"}} disabled className="type1-main-button" >
                                    <DynamicLoading height={"40px"} />
                                </button>
                            )  :  (
                                <button className="type1-main-button" onClick={() => setModalCadastrarColaboradorAberto(true)} >
                                    <FiUserPlus/>
                                    <span>Cadastrar colaborador</span>
                                </button>
                            )}

                        </div>

                        <label htmlFor="lista-tabelas-disponiveis" className="label-client-text">Colaboradores ativos</label>
                        <div className="tabela-generica-content-3">
                            {!done ? (
                                <div>
                                    <Loading />
                                </div>
                            )  :  (
                                <>
                                    <table className="table-pre-visualizacao">
                                        <thead>
                                            <tr className="texto-center-children">
                                                <th className="texto-center tabela-sem-quebra-linha">Matrícula</th>
                                                <th className="texto-center">Nome Completo</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Possui acesso</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Função</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Setor</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Superior Imediato</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Telefone 1</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Telefone 2</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Data cadastro</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Data última alteração</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Vínculo colaborador</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Editar</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {listaColaborador.length > 0 && listaColaborador
                                                .filter(colaborador => colaborador.colaborador_ativo === 1)
                                                .map(colaborador => {
                                                    return(
                                                        <tr key={colaborador.matricula_colaborador}>
                                                            <td style={{fontSize: "12px"}}>{colaborador.matricula_colaborador.replace(/(?<=\D)(?=\d)/, ' ')}</td>
                                                            <td>{colaborador.nome_completo_colaborador}</td>
                                                            <td>{colaborador.id_usuario_colaborador !== null ? ("Sim"):("NÃO")}</td>
                                                            <td>{colaborador.funcao_colaborador}</td>
                                                            <td>{colaborador.setor_colaborador}</td>
                                                            <td>{colaborador.nome_superior}</td>
                                                            <td>{colaborador.telefone1_colaborador}</td>
                                                            <td>{colaborador.telefone2_colaborador}</td>
                                                            <td>{(new Date(colaborador.data_cadastro_colaborador)).toLocaleDateString() + " - " + (new Date(colaborador.data_cadastro_colaborador)).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</td>
                                                            <td>{(new Date(colaborador.data_alteracao_colaborador)).toLocaleDateString() + " - " + (new Date(colaborador.data_alteracao_colaborador)).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</td>
                                                            <td>{colaborador.vinculo_colaborador}</td>

                                                            <td>
                                                                <div>
                                                                    <button onClick={() => {setDadosEditarColaborador(colaborador); setModalEditarColaboradorAberto(true);}} className="edit1">
                                                                        <FiEdit size={18} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                        
                                    </table>
                                </>
                            ) }
                        </div>

                        <label htmlFor="lista-tabelas-disponiveis" className="label-client-text">Colaboradores desligados</label>
                        <div className="tabela-generica-content-3">
                            {!done ? (
                                <div>
                                    <Loading />
                                </div>
                            )  :  (
                                <>
                                    <table className="table-pre-visualizacao">
                                        <thead>
                                            <tr className="texto-center-children">
                                                <th className="texto-center tabela-sem-quebra-linha">Matrícula</th>
                                                <th className="texto-center">Nome Completo</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Possui acesso</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Função</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Setor</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Superior Imediato</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Telefone 1</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Telefone 2</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Data cadastro</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Data última alteração</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Vínculo colaborador</th>
                                                <th className="texto-center tabela-sem-quebra-linha">Editar</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {listaColaborador.length > 0 && listaColaborador
                                                .filter(colaborador => colaborador.colaborador_ativo === 0)
                                                .filter(colaborador => colaborador.nome_colaborador !== "Nenhum")
                                                .map(colaborador => {
                                                    return(
                                                        <tr key={colaborador.matricula_colaborador}>
                                                            <td style={{fontSize: "12px"}}>{colaborador.matricula_colaborador.replace(/(?<=\D)(?=\d)/, ' ')}</td>
                                                            <td>{colaborador.nome_completo_colaborador}</td>
                                                            <td>{colaborador.id_usuario_colaborador !== null ? ("Sim"):("NÃO")}</td>
                                                            <td>{colaborador.funcao_colaborador}</td>
                                                            <td>{colaborador.setor_colaborador}</td>
                                                            <td>{colaborador.nome_superior}</td>
                                                            <td>{colaborador.telefone1_colaborador}</td>
                                                            <td>{colaborador.telefone2_colaborador}</td>
                                                            <td>{(new Date(colaborador.data_cadastro_colaborador)).toLocaleDateString() + " - " + (new Date(colaborador.data_cadastro_colaborador)).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</td>
                                                            <td>{(new Date(colaborador.data_alteracao_colaborador)).toLocaleDateString() + " - " + (new Date(colaborador.data_alteracao_colaborador)).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</td>
                                                            <td>{colaborador.vinculo_colaborador}</td>

                                                            <td>
                                                                <div>
                                                                    <button onClick={() => {setDadosEditarColaborador(colaborador); setModalEditarColaboradorAberto(true);}} className="edit1">
                                                                        <FiEdit size={18} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </>
                            ) }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}